/*
 * Reliance — Sélection multi-produits + ajout réel au panier (module générique).
 * Utilisé par sections/rel-diagnostic-composer.liquid (E.1r2), rel-diagnostic-cremes.liquid et
 * rel-diagnostic-routine.liquid (diagnostic visage, E.2r1 / E.2r2).
 * Ne connaît ni les fragrances ni les formats : la section propriétaire tient à jour les attributs de chaque article.
 *
 * CONTRAT data-*
 * Racine [data-rel-selection] (valeur « manual » : pas d'initialisation automatique, la section appelle
 *   RelSelectionCart.init(root, options)) ; data-money-format (shop.money_format) ; data-storage-key (optionnel,
 *   sessionStorage) ; data-refresh-event (optionnel : nom d'événement émis sur la racine qui déclenche refresh()).
 * Article [data-rel-selection-item="{clé stable}"] : data-variant-id, data-price (centimes), data-available
 *   ("true" | "false"), data-summary (libellé du récap), data-unavailable-label (texte du bouton si non ajoutable),
 *   data-item-title (optionnel, nom complet pour le nom accessible du bouton). Le module écrit data-selected.
 *   Bouton button[data-rel-selection-toggle] (aria-pressed écrit par le module) : data-label-add, data-label-added,
 *   data-label-remove (affiché au survol d'un article choisi, en CSS), data-label-template (« [action] : [product] »).
 * Barre [data-rel-selection-bar] : data-empty, data-empty-detail, data-count-one, data-count-other ([count]),
 *   data-label-submit, data-label-submitted, data-label-submitting, data-label-total, data-error ;
 *   enfants [data-rel-selection-summary], [data-rel-selection-detail], [data-rel-selection-total],
 *   button[data-rel-selection-submit], [data-rel-selection-live] (annonce polie), [data-rel-selection-error] (alerte).
 *   data-unstick-after (optionnel, sélecteur dans la racine ; par défaut l'élément qui précède la barre) : quand
 *   cette dernière ligne est visible, le module écrit data-unstuck="true" et la barre quitte sa position collante.
 *   Styles : assets/rel-selection.css.
 *
 * API : root.relSelection = { refresh(), select(key, on), toggle(key), clear(), getSelection(), getTotal(), submit() }
 *   Événements sur la racine : rel-selection:change, rel-selection:added, rel-selection:error.
 *   Options d'init : { saveState() → objet, restoreState(objet) } pour sauvegarder l'état propre à la section.
 * Global : RelSelectionCart.addToCart(lines, { trigger }) → Promise (lines = [{ id, quantity }]), réutilisable seul.
 */
(function () {
  if (window.RelSelectionCart) return;

  var STORAGE_VERSION = 1;

  function formatMoney(cents, format) {
    var value = Number(cents) || 0;
    var pattern = format || '{{amount_with_comma_separator}} €';
    function delimit(number, precision, thousands, decimal) {
      var fixed = (number / 100).toFixed(precision);
      var parts = fixed.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      return parts[1] ? whole + decimal + parts[1] : whole;
    }
    return pattern.replace(/\{\{\s*(\w+)\s*\}\}/, function (match, key) {
      switch (key) {
        case 'amount_no_decimals':
          return delimit(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return delimit(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return delimit(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator':
          return delimit(value, 2, "'", '.');
        case 'amount_with_space_separator':
          return delimit(value, 2, ' ', ',');
        case 'amount_no_decimals_with_space_separator':
          return delimit(value, 0, ' ', ',');
        default:
          return delimit(value, 2, ',', '.');
      }
    });
  }

  function readStorage(key) {
    if (!key) return null;
    try {
      var raw = window.sessionStorage.getItem(key);
      if (!raw) return null;
      var data = JSON.parse(raw);
      return data && data.v === STORAGE_VERSION ? data : null;
    } catch (e) {
      return null;
    }
  }

  function writeStorage(key, data) {
    if (!key) return;
    try {
      window.sessionStorage.setItem(key, JSON.stringify(data));
    } catch (e) {
      /* stockage indisponible (navigation privée, quota) : la sélection reste en mémoire */
    }
  }

  function themeCart() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  /* Reproduit assets/product-form.js : section rendering du tiroir ou de la notification, sinon /cart. */
  function renderThemeCart(cart, response) {
    var items = response.items || [];
    if (cart.tagName === 'CART-NOTIFICATION') {
      cart.renderContents(Object.assign({}, response, { key: items[0] && items[0].key }));
      var target = document.getElementById('cart-notification-product');
      var html = response.sections && response.sections['cart-notification-product'];
      if (target && html && items.length > 1) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var seen = {};
        target.innerHTML = '';
        items.forEach(function (item) {
          if (seen[item.key]) return;
          seen[item.key] = true;
          var node = doc.querySelector('[id="cart-notification-product-' + item.key + '"]');
          if (node) target.appendChild(document.importNode(node, true));
        });
      }
    } else {
      cart.renderContents(response);
      var inner = cart.querySelector('.drawer__inner');
      if (inner) inner.classList.remove('is-empty');
    }
    if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
  }

  function addToCart(lines, options) {
    options = options || {};
    var cart = themeCart();
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var body = { items: lines };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (section) {
        return section.id;
      });
      body.sections_url = window.location.pathname;
      if (typeof cart.setActiveElement === 'function') cart.setActiveElement(options.trigger || document.activeElement);
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body),
    })
      .then(function (res) {
        return res.json().then(function (data) {
          if (!res.ok || data.status) {
            var error = new Error(data.description || data.message || 'cart/add');
            error.description = data.description || data.message || '';
            throw error;
          }
          return data;
        });
      })
      .then(function (data) {
        if (!cart || !data.sections) {
          window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
          return data;
        }
        try {
          renderThemeCart(cart, data);
        } catch (e) {
          window.location.href = (window.routes && window.routes.cart_url) || root + 'cart';
        }
        return data;
      });
  }

  function init(root, options) {
    if (root.relSelection) return root.relSelection;
    options = options || {};
    var storageKey = root.getAttribute('data-storage-key');
    var moneyFormat = root.getAttribute('data-money-format');
    var bar = root.querySelector('[data-rel-selection-bar]');
    var submit = bar && bar.querySelector('[data-rel-selection-submit]');
    var live = bar && bar.querySelector('[data-rel-selection-live]');
    var errorBox = bar && bar.querySelector('[data-rel-selection-error]');
    var selected = {};
    var restoring = false;
    var busy = false;
    var submitted = false;
    var lastAnnounce = '';

    function items() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-rel-selection-item]'));
    }

    function itemFor(key) {
      return items().filter(function (el) {
        return el.getAttribute('data-rel-selection-item') === key;
      })[0];
    }

    function isAvailable(el) {
      return el.getAttribute('data-available') === 'true' && !!el.getAttribute('data-variant-id');
    }

    function getSelection() {
      return items()
        .filter(function (el) {
          return selected[el.getAttribute('data-rel-selection-item')] && isAvailable(el);
        })
        .map(function (el) {
          return {
            key: el.getAttribute('data-rel-selection-item'),
            variantId: Number(el.getAttribute('data-variant-id')),
            price: Number(el.getAttribute('data-price')) || 0,
            summary: el.getAttribute('data-summary') || '',
          };
        });
    }

    function getTotal() {
      return getSelection().reduce(function (sum, line) {
        return sum + line.price;
      }, 0);
    }

    function renderItem(el) {
      var key = el.getAttribute('data-rel-selection-item');
      var available = isAvailable(el);
      if (!available) delete selected[key];
      var on = !!selected[key];
      el.setAttribute('data-selected', on ? 'true' : 'false');
      var toggle = el.querySelector('[data-rel-selection-toggle]');
      if (!toggle) return;
      toggle.disabled = !available;
      toggle.setAttribute('aria-pressed', on ? 'true' : 'false');
      var text = available
        ? toggle.getAttribute(on ? 'data-label-added' : 'data-label-add')
        : el.getAttribute('data-unavailable-label') || '';
      toggle.textContent = text;
      var template = toggle.getAttribute('data-label-template');
      var title = el.getAttribute('data-item-title');
      if (template && title) {
        toggle.setAttribute('aria-label', template.replace('[action]', text.replace(/^✓\s*/, '')).replace('[product]', title));
      }
    }

    function renderBar() {
      if (!bar) return;
      var lines = getSelection();
      var count = lines.length;
      var summary = bar.querySelector('[data-rel-selection-summary]');
      var detail = bar.querySelector('[data-rel-selection-detail]');
      var total = bar.querySelector('[data-rel-selection-total]');
      var countText = count
        ? (bar.getAttribute(count === 1 ? 'data-count-one' : 'data-count-other') || '').replace('[count]', count)
        : bar.getAttribute('data-empty') || '';
      var totalText = count ? formatMoney(getTotal(), moneyFormat) : '';
      if (summary) summary.textContent = countText;
      if (detail) {
        detail.textContent = count
          ? lines
              .map(function (line) {
                return line.summary;
              })
              .join(' · ')
          : bar.getAttribute('data-empty-detail') || '';
      }
      if (total) total.textContent = totalText;
      if (submit) {
        submit.disabled = !count || busy;
        submit.setAttribute('aria-busy', busy ? 'true' : 'false');
        submit.textContent = bar.getAttribute(
          busy ? 'data-label-submitting' : submitted ? 'data-label-submitted' : 'data-label-submit'
        );
      }
      if (live) {
        var announce = count ? countText + ' — ' + (bar.getAttribute('data-label-total') || '') + ' ' + totalText : countText;
        if (announce !== lastAnnounce) {
          live.textContent = announce;
          lastAnnounce = announce;
        }
      }
    }

    function setError(message) {
      if (errorBox) errorBox.textContent = message || '';
    }

    function save() {
      if (!storageKey || restoring) return;
      writeStorage(storageKey, {
        v: STORAGE_VERSION,
        selected: Object.keys(selected),
        extra: typeof options.saveState === 'function' ? options.saveState() : null,
      });
    }

    function emit() {
      root.dispatchEvent(
        new CustomEvent('rel-selection:change', {
          bubbles: true,
          detail: { items: getSelection(), total: getTotal() },
        })
      );
    }

    function refresh() {
      if (restoring) return;
      submitted = false;
      setError('');
      items().forEach(renderItem);
      renderBar();
      save();
      emit();
    }

    function select(key, on) {
      var el = itemFor(key);
      if (!el) return;
      if (on && isAvailable(el)) selected[key] = true;
      else delete selected[key];
      refresh();
    }

    function toggle(key) {
      select(key, !selected[key]);
    }

    function clear() {
      selected = {};
      refresh();
    }

    function doSubmit() {
      var lines = getSelection();
      if (!lines.length || busy) return Promise.resolve(null);
      busy = true;
      setError('');
      renderBar();
      return addToCart(
        lines.map(function (line) {
          return { id: line.variantId, quantity: 1 };
        }),
        { trigger: submit }
      )
        .then(function (data) {
          busy = false;
          submitted = true;
          renderBar();
          root.dispatchEvent(new CustomEvent('rel-selection:added', { bubbles: true, detail: data }));
          return data;
        })
        .catch(function (error) {
          busy = false;
          submitted = false;
          renderBar();
          var message = (error && error.description) || (bar && bar.getAttribute('data-error')) || '';
          setError(message);
          root.dispatchEvent(new CustomEvent('rel-selection:error', { bubbles: true, detail: { message: message } }));
          return null;
        });
    }

    items().forEach(function (el) {
      var button = el.querySelector('[data-rel-selection-toggle]');
      if (!button) return;
      button.addEventListener('click', function () {
        toggle(el.getAttribute('data-rel-selection-item'));
      });
    });

    if (submit) submit.addEventListener('click', doSubmit);

    /* La barre collante ne doit recouvrir aucun bouton : quand la dernière ligne de la section est entièrement
       visible au-dessus de la zone occupée par la barre, la barre reprend sa place dans le flux (data-unstuck,
       CSS rel-selection.css). Seuil 1 et non 0 : avec 0, la barre quittait l'écran dès l'apparition du haut
       de cette ligne, avant la fin de la section. Ligne plus haute que l'écran : la barre reste collante
       et s'arrête d'elle-même en fin de section (position: sticky). */
    var lastRow = bar && (bar.getAttribute('data-unstick-after') ? root.querySelector(bar.getAttribute('data-unstick-after')) : bar.previousElementSibling);
    if (lastRow && 'IntersectionObserver' in window) {
      new IntersectionObserver(
        function (entries) {
          bar.setAttribute('data-unstuck', entries[entries.length - 1].intersectionRatio >= 0.99 ? 'true' : 'false');
        },
        { rootMargin: '0px 0px -' + Math.round(bar.offsetHeight || 0) + 'px 0px', threshold: 1 }
      ).observe(lastRow);
    }

    var refreshEvent = root.getAttribute('data-refresh-event');
    if (refreshEvent) root.addEventListener(refreshEvent, refresh);

    /* Restauration : état propre à la section d'abord (variantes), puis la sélection. */
    var saved = readStorage(storageKey);
    if (saved) {
      restoring = true;
      try {
        if (saved.extra && typeof options.restoreState === 'function') options.restoreState(saved.extra);
      } catch (e) {
        /* état corrompu : on garde le rendu par défaut */
      }
      restoring = false;
      (Array.isArray(saved.selected) ? saved.selected : []).forEach(function (key) {
        var el = itemFor(key);
        if (el && isAvailable(el)) selected[key] = true;
      });
    }
    items().forEach(renderItem);
    renderBar();
    if (live) live.textContent = ''; /* pas d'annonce au chargement */

    root.relSelection = {
      refresh: refresh,
      select: select,
      toggle: toggle,
      clear: clear,
      getSelection: getSelection,
      getTotal: getTotal,
      submit: doSubmit,
    };
    return root.relSelection;
  }

  window.RelSelectionCart = { init: init, addToCart: addToCart, formatMoney: formatMoney };

  function boot() {
    document.querySelectorAll('[data-rel-selection]').forEach(function (root) {
      if (root.getAttribute('data-rel-selection') === 'manual' || root.relSelection) return;
      init(root);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', boot);
})();
